export default __webpack_public_path__ + "static/media/gallery_13.4da07472.jpg";